import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

/** Delete a clinic group. Its Group Admin users then see no clinics. */
export const deleteClinicGroupApi = createAsyncThunk(
  'clinicGroups/delete',
  async (id: string, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'DELETE',
        // No Content-Type: Fastify refuses an empty body declared as JSON.
        headers: { Authorization: 'Bearer ' + getToken() },
      };

      const res = await fetch(CLINICS.CLINIC_GROUP_URL(id), requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to delete clinic group');
      }

      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
